import { api } from '@/services/api';
import { AxiosApiError, getApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_SERVICE_ACCOUNT_QUERY_KEY } from './useGetServiceAccount';

interface CreateServiceAccountRequest {
  name: string;
}

export const useCreateServiceAccount = () => {
  const queryClient = useQueryClient();
  const { mutate, isPending, error, reset, data } = useMutation<
    Awaited<ReturnType<typeof api.users.createUserServiceAccount>>,
    AxiosApiError,
    CreateServiceAccountRequest
  >({
    mutationFn: (data: CreateServiceAccountRequest) => api.users.createUserServiceAccount(data),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [GET_SERVICE_ACCOUNT_QUERY_KEY] });
    },
  });

  return {
    createServiceAccount: mutate,
    isCreating: isPending,
    error: getApiError(error),
    resetCreateError: reset,
    mutationData: data,
  };
};
